import React, { Component } from 'react';
import './Info.css';
import {ajax} from '../../Context';
import Spinner from "../Elements/Spinner/Spinner";

const AJAX_TYPE = '135795';

class Info extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    componentDidMount() {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&uhash=' + this.props.hash)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }

    render() {
        if(this.state.data) {
            return (
                <div>
                    <div className="shared-content" dangerouslySetInnerHTML={{__html:this.state.data.html}} />
                </div>
            )
        }else{
            return <Spinner message="" />;
        }

    }
}
export default Info;


// WEBPACK FOOTER //
// ./src/Components/Info/Info.js